import { render, staticRenderFns } from "./InputText.vue?vue&type=template&id=0a55f755&scoped=true"
import script from "./InputText.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputText.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InputText.vue?vue&type=style&index=0&id=0a55f755&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a55f755",
  null
  
)

export default component.exports